export const kktuCodes = [
    {
        code: '1',
        name: 'АЛКОГОЛЬНЫЕ НАПИТКИ, ТАБАЧНЫЕ ИЗДЕЛИЯ',
        children: [
            {
                code: '1.1',
                name: 'АЛКОГОЛЬНЫЕ НАПИТКИ',
                children: [
                    {
                        code: '1.1.1',
                        name: 'ВИНО'
                    },
                    {
                        code: '1.1.2',
                        name: 'КРЕПКИЕ АЛКОГОЛЬНЫЕ НАПИТКИ'
                    },
                    {
                        code: '1.1.3',
                        name: 'АЛКОГОЛЬНЫЕ НАПИТКИ (РАЗНОЕ)'
                    },
                    {
                        code: '1.1.4',
                        name: 'СЛАБОАЛКОГОЛЬНЫЕ НАПИТКИ'
                    }
                ]
            },
            {
                code: '1.2',
                name: 'ТАБАЧНЫЕ ИЗДЕЛИЯ',
                children: [
                    {
                        code: '1.2.1',
                        name: 'ТАБАЧНЫЕ ИЗДЕЛИЯ'
                    }
                ]
            }
        ]
    },
    {
        code: '2',
        name: 'АУДИО- И ВИДЕОАППАРАТУРА',
        children: [
            {
                code: '2.1',
                name: 'АУДИО- И ВИДЕОАППАРАТУРА',
                children: [
                    {
                        code: '2.1.1',
                        name: 'АУДИОАППАРАТУРА'
                    },
                    {
                        code: '2.1.2',
                        name: 'ТВ И ВИДЕОАППАРАТУРА'
                    },
                    {
                        code: '2.1.3',
                        name: 'ФОТОАППАРАТУРА'
                    },
                    {
                        code: '2.1.4',
                        name: 'АУДИО, ВИДЕО, КИНО И ФОТОТЕХНИКА (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '3',
        name: 'БЫТОВАЯ ТЕХНИКА',
        children: [
            {
                code: '3.1',
                name: 'КРУПНАЯ БЫТОВАЯ ТЕХНИКА',
                children: [
                    {
                        code: '3.1.1',
                        name: 'СТИРАЛЬНЫЕ МАШИНЫ'
                    },
                    {
                        code: '3.1.2',
                        name: 'ХОЛОДИЛЬНИКИ'
                    },
                    {
                        code: '3.1.3',
                        name: 'КРУПНАЯ БЫТОВАЯ ТЕХНИКА (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '3.2',
                name: 'МЕЛКАЯ И СРЕДНЯЯ БЫТОВАЯ ТЕХНИКА',
                children: [
                    {
                        code: '3.2.1',
                        name: 'МЕЛКАЯ И СРЕДНЯЯ БЫТОВАЯ ТЕХНИКА'
                    }
                ]
            }
        ]
    },
    {
        code: '4',
        name: 'БЫТОВАЯ ХИМИЯ',
        children: [
            {
                code: '4.1',
                name: 'МОЮЩИЕ И ЧИСТЯЩИЕ СРЕДСТВА',
                children: [
                    {
                        code: '4.1.1',
                        name: 'СРЕДСТВА ДЛЯ МЫТЬЯ ПОСУДЫ'
                    },
                    {
                        code: '4.1.2',
                        name: 'СРЕДСТВА ДЛЯ СТИРКИ'
                    },
                    {
                        code: '4.1.3',
                        name: 'ЧИСТЯЩИЕ СРЕДСТВА'
                    },
                    {
                        code: '4.1.4',
                        name: 'МОЮЩИЕ И ЧИСТЯЩИЕ СРЕДСТВА (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '4.2',
                name: 'СРЕДСТВА БОРЬБЫ С НАСЕКОМЫМИ',
                children: [
                    {
                        code: '4.2.1',
                        name: 'СРЕДСТВА БОРЬБЫ С НАСЕКОМЫМИ'
                    }
                ]
            },
            {
                code: '4.3',
                name: 'БЫТОВАЯ ХИМИЯ (ПРОЧЕЕ)',
                children: [
                    {
                        code: '4.3.1',
                        name: 'СР-ВА ПО УХОДУ ЗА ОДЕЖДОЙ И ОБУВЬЮ'
                    },
                    {
                        code: '4.3.2',
                        name: 'БЫТОВАЯ ХИМИЯ (ЯДОХИМИКАТЫ)'
                    },
                    {
                        code: '4.3.3',
                        name: 'БЫТОВАЯ ХИМИЯ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '5',
        name: 'ДОСУГ, РАЗВЛЕЧЕНИЯ, ТУРИЗМ, ОТДЫХ',
        children: [
            {
                code: '5.1',
                name: 'ЛОТЕРЕИ, УСЛУГИ БУКМЕКЕРСКИЕ',
                children: [
                    {
                        code: '5.1.1',
                        name: 'ЛОТЕРЕИ И РОЗЫГРЫШИ ПРИЗОВ'
                    },
                    {
                        code: '5.1.2',
                        name: 'УСЛУГИ БУКМЕКЕРСКИЕ'
                    }
                ]
            },
            {
                code: '5.2',
                name: 'ДОСУГ И РАЗВЛЕЧЕНИЯ',
                children: [
                    {
                        code: '5.2.1',
                        name: 'ДОСУГ'
                    },
                    {
                        code: '5.2.2',
                        name: 'КИНОТЕАТРЫ'
                    },
                    {
                        code: '5.2.3',
                        name: 'КОНКУРСЫ, ВИКТОРИНЫ'
                    },
                    {
                        code: '5.2.4',
                        name: 'КУЛЬТУРНЫЕ И РАЗВЛЕКАТЕЛЬНЫЕ УЧРЕЖДЕНИЯ'
                    },
                    {
                        code: '5.2.5',
                        name: 'РАЗВЛЕКАТЕЛЬНЫЕ ЗРЕЛИЩА'
                    },
                    {
                        code: '5.2.6',
                        name: 'СПЕЦИАЛИЗИРОВАННЫЕ МЕРОПРИЯТИЯ'
                    },
                    {
                        code: '5.2.7',
                        name: 'ПРАЗДНИЧНЫЕ ТОВАРЫ'
                    },
                    {
                        code: '5.2.8',
                        name: 'ИГРОВЫЕ АВТОМАТЫ (B2B)'
                    },
                    {
                        code: '5.2.9',
                        name: 'ИНФОРМАЦИОННО-РАЗВЛЕКАТЕЛЬНЫЕ УСЛУГИ СОТОВОЙ СВЯЗИ'
                    },
                    {
                        code: '5.2.10',
                        name: 'ИНФОРМАЦИОННОЕ СООБЩЕНИЕ'
                    },
                    {
                        code: '5.2.11',
                        name: 'ДОСУГ И РАЗВЛЕЧЕНИЯ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '5.3',
                name: 'ТУРИЗМ И ОТДЫХ',
                children: [
                    {
                        code: '5.3.1',
                        name: 'ТУРИЗМ И ОТДЫХ'
                    }
                ]
            }
        ]
    },
    {
        code: '6',
        name: 'ИНТЕРНЕТ-СЕРВИСЫ',
        children: [
            {
                code: '6.1',
                name: 'ИНТЕРНЕТ-СЕРВИСЫ',
                children: [
                    {
                        code: '6.1.1',
                        name: 'ИНТЕРНЕТ-СЕРВИСЫ'
                    }
                ]
            }
        ]
    },
    {
        code: '7',
        name: 'ИНТЕРНЕТ-ТОРГОВЛЯ',
        children: [
            {
                code: '7.1',
                name: 'ИНТЕРНЕТ-ТОРГОВЛЯ',
                children: [
                    {
                        code: '7.1.1',
                        name: 'МАРКЕТПЛЕЙСЫ'
                    },
                    {
                        code: '7.1.2',
                        name: 'ИНТЕРНЕТ-ТОРГОВЛЯ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '8',
        name: 'КАФЕ И РЕСТОРАНЫ',
        children: [
            {
                code: '8.1',
                name: 'КАФЕ И РЕСТОРАНЫ',
                children: [
                    {
                        code: '8.1.1',
                        name: 'КАФЕ И РЕСТОРАНЫ'
                    }
                ]
            }
        ]
    },
    {
        code: '9',
        name: 'КОМПЬЮТЕРНАЯ ТЕХНИКА И ПРОГРАММНОЕ ОБЕСПЕЧЕНИЕ',
        children: [
            {
                code: '9.1',
                name: 'КОМПЬЮТЕРЫ И ОРГТЕХНИКА',
                children: [
                    {
                        code: '9.1.1',
                        name: 'КОМПЬЮТЕРЫ'
                    },
                    {
                        code: '9.1.2',
                        name: 'ПОРТАТИВНЫЕ КОМПЬЮТЕРЫ'
                    },
                    {
                        code: '9.1.3',
                        name: 'КОМПЬЮТЕРНАЯ ПЕРИФЕРИЯ'
                    },
                    {
                        code: '9.1.4',
                        name: 'КОМПЬЮТЕРНЫЕ КОМПЛЕКТУЮЩИЕ'
                    },
                    {
                        code: '9.1.5',
                        name: 'ОФИСНАЯ ТЕХНИКА'
                    },
                    {
                        code: '9.1.6',
                        name: 'СИСТЕМЫ НА БАЗЕ КОМПЬЮТЕРНОЙ ТЕХНИКИ'
                    },
                    {
                        code: '9.1.7',
                        name: 'КАЛЬКУЛЯТОРЫ, ЭЛЕКТРОННЫЕ ЗАПИСНЫЕ КНИЖКИ'
                    },
                    {
                        code: '9.1.8',
                        name: 'КОМПЬЮТЕРЫ И ОРГТЕХНИКА (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '9.2',
                name: 'ПРОГРАММНОЕ ОБЕСПЕЧЕНИЕ',
                children: [
                    {
                        code: '9.2.1',
                        name: 'ПРОГРАММНОЕ ОБЕСПЕЧЕНИЕ'
                    }
                ]
            }
        ]
    },
    {
        code: '10',
        name: 'ТРАНСПОРТНЫЕ СРЕДСТВА',
        children: [
            {
                code: '10.1',
                name: 'ЛЕГКОВЫЕ АВТОМОБИЛИ',
                children: [
                    {
                        code: '10.1.1',
                        name: 'ЛЕГКОВЫЕ АВТОМОБИЛИ'
                    }
                ]
            },
            {
                code: '10.2',
                name: 'ГРУЗОВЫЕ АВТОМОБИЛИ И АВТОБУСЫ',
                children: [
                    {
                        code: '10.2.1',
                        name: 'ГРУЗОВЫЕ АВТОМОБИЛИ И ПИКАПЫ'
                    },
                    {
                        code: '10.2.2',
                        name: 'АВТОБУСЫ И МИКРОАВТОБУСЫ'
                    }
                ]
            },
            {
                code: '10.3',
                name: 'МОТОТЕХНИКА',
                children: [
                    {
                        code: '10.3.1',
                        name: 'МОТОТЕХНИКА'
                    }
                ]
            },
            {
                code: '10.4',
                name: 'СПОРТИВНЫЕ СУДА И ТЕХНИКА',
                children: [
                    {
                        code: '10.4.1',
                        name: 'ВОДНЫЙ ТРАНСПОРТ'
                    },
                    {
                        code: '10.4.2',
                        name: 'СНЕГОХОДЫ, ВЕЗДЕХОДЫ'
                    }
                ]
            },
            {
                code: '10.5',
                name: 'АВТОТРАНСПОРТ (ПРОЧЕЕ)',
                children: [
                    {
                        code: '10.5.1',
                        name: 'АВТОТРАНСПОРТ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '10.6',
                name: 'СТРОИТЕЛЬНАЯ, СЕЛЬСКОХОЗЯЙСТВЕННАЯ, ДОРОЖНАЯ И ДРУГАЯ АВТОЕХНИКА',
                children: [
                    {
                        code: '10.6.1',
                        name: 'ТРАКТОРЫ, СТРОИТЕЛЬНАЯ И ДОРОЖНАЯ ТЕХНИКА'
                    },
                    {
                        code: '10.6.2',
                        name: 'СЕЛЬСКОХОЗЯЙСТВЕННАЯ ТЕХНИКА'
                    },
                    {
                        code: '10.6.3',
                        name: 'ТЕХНИКА ДЛЯ КОММУНАЛЬНОГО ХОЗЯЙСТВА'
                    }
                ]
            },
            {
                code: '10.7',
                name: 'ТРАНСПОРТНЫЕ СРЕДСТВА (ПРОЧЕЕ)',
                children: [
                    {
                        code: '10.7.1',
                        name: 'ТРАНСПОРТНЫЕ СРЕДСТВА (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '10.8',
                name: 'АВТОСЕРВИС',
                children: [
                    {
                        code: '10.8.1',
                        name: 'АВТОСЕРВИС'
                    }
                ]
            },
            {
                code: '10.9',
                name: 'ТОВАРЫ ДЛЯ АВТОМОБИЛЕЙ',
                children: [
                    {
                        code: '10.9.1',
                        name: 'АВТОАКСЕССУАРЫ'
                    },
                    {
                        code: '10.9.2',
                        name: 'АВТОЗАПЧАСТИ'
                    },
                    {
                        code: '10.9.3',
                        name: 'АВТОМОБИЛЬНАЯ АУДИОТЕХНИКА'
                    },
                    {
                        code: '10.9.4',
                        name: 'АВТОМОБИЛЬНАЯ БЫТОВАЯ ТЕХНИКА'
                    },
                    {
                        code: '10.9.5',
                        name: 'АВТОХИМИЯ'
                    },
                    {
                        code: '10.9.6',
                        name: 'АВТОШИНЫ'
                    },
                    {
                        code: '10.9.7',
                        name: 'АВТОЭЛЕКТРОНИКА (РАЗНОЕ)'
                    },
                    {
                        code: '10.9.8',
                        name: 'ГСМ И РАСХОДНЫЕ МАТЕРИАЛЫ'
                    },
                    {
                        code: '10.9.9',
                        name: 'МОТОРНОЕ МАСЛО'
                    },
                    {
                        code: '10.9.10',
                        name: 'ОБОРУДОВАНИЕ ДЛЯ АВТОТЕХНИКИ'
                    }
                ]
            }
        ]
    },
    {
        code: '11',
        name: 'МЕБЕЛЬ, ПРЕДМЕТЫ ИНТЕРЬЕРА',
        children: [
            {
                code: '11.1',
                name: 'МЕБЕЛЬ, ПРЕДМЕТЫ ИНТЕРЬЕРА',
                children: [
                    {
                        code: '11.1.1',
                        name: 'МЕБЕЛЬ'
                    },
                    {
                        code: '11.1.2',
                        name: 'ПРЕДМЕТЫ ИНТЕРЬЕРА'
                    },
                    {
                        code: '11.1.3',
                        name: 'КУХОННЫЕ И ХОЗЯЙСТВЕННЫЕ ПРИНАДЛЕЖНОСТИ'
                    }
                ]
            }
        ]
    },
    {
        code: '12',
        name: 'МЕДИЦИНА И ФАРМАЦЕВТИКА',
        children: [
            {
                code: '12.1',
                name: 'МЕДИЦИНСКИЕ ТОВАРЫ И УСЛУГИ',
                children: [
                    {
                        code: '12.1.1',
                        name: 'МЕДИЦИНСКИЕ МАТЕРИАЛЫ И ОБОРУДОВАНИЕ'
                    },
                    {
                        code: '12.1.2',
                        name: 'МЕДИЦИНСКИЕ УСЛУГИ'
                    },
                    {
                        code: '12.1.3',
                        name: 'ОПТИКА'
                    }
                ]
            },
            {
                code: '12.2',
                name: 'ФАРМАЦЕВТИЧЕСКИЕ ТОВАРЫ',
                children: [
                    {
                        code: '12.2.1',
                        name: 'БИОЛОГИЧЕСКИЕ ПИЩЕВЫЕ ДОБАВКИ'
                    },
                    {
                        code: '12.2.2',
                        name: 'ЛЕКАРСТВЕННЫЕ ПРЕПАРАТЫ'
                    },
                    {
                        code: '12.2.3',
                        name: 'СПЕЦИАЛЬНЫЕ ЛЕКАРСТВЕННЫЕ СРЕДСТВА'
                    },
                    {
                        code: '12.2.4',
                        name: 'ПРЕЗЕРВАТИВЫ'
                    },
                    {
                        code: '12.2.5',
                        name: 'ФАРМАЦЕВТИЧЕСКИЕ ТОВАРЫ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '13',
        name: 'НЕДВИЖИМОСТЬ',
        children: [
            {
                code: '13.1',
                name: 'НЕДВИЖИМОСТЬ',
                children: [
                    {
                        code: '13.1.1',
                        name: 'ГАРАЖИ И ГАРАЖНОЕ ОБОРУДОВАНИЕ'
                    },
                    {
                        code: '13.1.2',
                        name: 'ЖИЛАЯ НЕДВИЖИМОСТЬ'
                    },
                    {
                        code: '13.1.3',
                        name: 'ЗАГОРОДНАЯ НЕДВИЖИМОСТЬ'
                    },
                    {
                        code: '13.1.4',
                        name: 'НЕДВИЖИМОСТЬ (РАЗНОЕ)'
                    },
                    {
                        code: '13.1.5',
                        name: 'НЕЖИЛАЯ НЕДВИЖИМОСТЬ'
                    }
                ]
            }
        ]
    },
    {
        code: '14',
        name: 'ОДЕЖДА И ОБУВЬ',
        children: [
            {
                code: '14.1',
                name: 'ОДЕЖДА И ОБУВЬ',
                children: [
                    {
                        code: '14.1.1',
                        name: 'ДЕТСКАЯ ОДЕЖДА'
                    },
                    {
                        code: '14.1.2',
                        name: 'ЖЕНСКАЯ ОДЕЖДА'
                    },
                    {
                        code: '14.1.3',
                        name: 'МУЖСКАЯ ОДЕЖДА'
                    },
                    {
                        code: '14.1.4',
                        name: 'СПОРТИВНАЯ ОДЕЖДА'
                    },
                    {
                        code: '14.1.5',
                        name: 'НИЖНЕЕ БЕЛЬЕ'
                    },
                    {
                        code: '14.1.6',
                        name: 'ОДЕЖДА (ПРОЧЕЕ)'
                    },
                    {
                        code: '14.1.7',
                        name: 'ДЕТСКАЯ ОБУВЬ'
                    },
                    {
                        code: '14.1.8',
                        name: 'ЖЕНСКАЯ ОБУВЬ'
                    },
                    {
                        code: '14.1.9',
                        name: 'МУЖСКАЯ ОБУВЬ'
                    },
                    {
                        code: '14.1.10',
                        name: 'СПОРТИВНАЯ ОБУВЬ'
                    },
                    {
                        code: '14.1.11',
                        name: 'ОБУВЬ (РАЗНОЕ)'
                    },
                    {
                        code: '14.1.12',
                        name: 'ОДЕЖДА И ОБУВЬ (РАЗНОЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '15',
        name: 'ПАРФЮМЕРИЯ И КОСМЕТИКА',
        children: [
            {
                code: '15.1',
                name: 'СРЕДСТВА ПО УХОДУ ЗА ВОЛОСАМИ',
                children: [
                    {
                        code: '15.1.1',
                        name: 'ДЕТСКИЙ ШАМПУНЬ'
                    },
                    {
                        code: '15.1.2',
                        name: 'СРЕДСТВА ПО УХОДУ ЗА ВОЛОСАМИ'
                    },
                    {
                        code: '15.1.3',
                        name: 'ШАМПУНЬ'
                    },
                    {
                        code: '15.1.4',
                        name: 'СРЕДСТВА ПО УХОДУ ЗА ВОЛОСАМИ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '15.2',
                name: 'СРЕДСТВА ПО УХОДУ ЗА КОЖЕЙ',
                children: [
                    {
                        code: '15.2.1',
                        name: 'ГЕЛЬ ДЛЯ ДУША'
                    },
                    {
                        code: '15.2.2',
                        name: 'МЫЛО'
                    },
                    {
                        code: '15.2.3',
                        name: 'СРЕДСТВА ДЛЯ БРИТЬЯ И ЭПИЛЯЦИИ (РАЗНОЕ)'
                    },
                    {
                        code: '15.2.4',
                        name: 'СРЕДСТВА ДЛЯ И ПОСЛЕ БРИТЬЯ'
                    },
                    {
                        code: '15.2.5',
                        name: 'СРЕДСТВА ДЛЯ УДАЛЕНИЯ ВОЛОС'
                    },
                    {
                        code: '15.2.6',
                        name: 'СРЕДСТВА ПО УХОДУ ЗА КОЖЕЙ'
                    }
                ]
            },
            {
                code: '15.3',
                name: 'ПАРФЮМЕРИЯ И КОСМЕТИКА (ПРОЧЕЕ)',
                children: [
                    {
                        code: '15.3.1',
                        name: 'ДЕЗОДОРАНТЫ'
                    },
                    {
                        code: '15.3.2',
                        name: 'ДЕКОРАТИВНАЯ КОСМЕТИКА'
                    },
                    {
                        code: '15.3.3',
                        name: 'ПАРФЮМЕРИЯ'
                    },
                    {
                        code: '15.3.4',
                        name: 'СРЕДСТВА ПО УХОДУ ЗА НОГТЯМИ'
                    },
                    {
                        code: '15.3.5',
                        name: 'ТОВАРЫ ДЛЯ КРАСОТЫ И ЗДОРОВЬЯ (РАЗНОЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '16',
        name: 'ПИВО',
        children: [
            {
                code: '16.1',
                name: 'ПИВО',
                children: [
                    {
                        code: '16.1.1',
                        name: 'ПИВО'
                    },
                    {
                        code: '16.1.2',
                        name: 'ПИВО (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '17',
        name: 'ПРОДУКТЫ ПИТАНИЯ',
        children: [
            {
                code: '17.1',
                name: 'МОЛОКО, МОЛОЧНАЯ ПРОДУКЦИЯ',
                children: [
                    {
                        code: '17.1.1',
                        name: 'ЙОГУРТЫ'
                    },
                    {
                        code: '17.1.2',
                        name: 'МАСЛОЖИРОВАЯ ПРОДУКЦИЯ'
                    },
                    {
                        code: '17.1.3',
                        name: 'МОЛОКО, МОЛОЧНАЯ ПРОДУКЦИЯ'
                    }
                ]
            },
            {
                code: '17.2',
                name: 'ПРОДУКТЫ БЫСТРОГО ПРИГОТОВЛЕНИЯ',
                children: [
                    {
                        code: '17.2.1',
                        name: 'БУЛЬОННЫЕ КУБИКИ'
                    },
                    {
                        code: '17.2.2',
                        name: 'КАШИ БЫСТРОГО ПРИГОТОВЛЕНИЯ'
                    },
                    {
                        code: '17.2.3',
                        name: 'ПРОДУКТЫ БЫСТРОГО ПРИГОТОВЛЕНИЯ'
                    }
                ]
            },
            {
                code: '17.3',
                name: 'ЧАЙ, КОФЕ, КАКАО',
                children: [
                    {
                        code: '17.3.1',
                        name: 'КОФЕ'
                    },
                    {
                        code: '17.3.2',
                        name: 'КАКАО'
                    },
                    {
                        code: '17.3.3',
                        name: 'КОФЕ И КАКАО (РАЗНОЕ)'
                    },
                    {
                        code: '17.3.4',
                        name: 'ЧАЙ'
                    }
                ]
            },
            {
                code: '17.4',
                name: 'ШОКОЛАД И ШОКОЛАДНЫЕ ИЗДЕЛИЯ',
                children: [
                    {
                        code: '17.4.1',
                        name: 'ШОКОЛАДНЫЕ БАТОНЧИКИ'
                    },
                    {
                        code: '17.4.2',
                        name: 'ШОКОЛАДНЫЕ КОНФЕТЫ В КОРОБКАХ'
                    },
                    {
                        code: '17.4.3',
                        name: 'ШОКОЛАД И ШОКОЛАДНЫЕ ИЗДЕЛИЯ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '17.5',
                name: 'ПРОДУКТЫ ПИТАНИЯ (ПРОЧЕЕ)',
                children: [
                    {
                        code: '17.5.1',
                        name: 'БАКАЛЕЯ И КУЛИНАРИЯ'
                    },
                    {
                        code: '17.5.2',
                        name: 'ДЕТСКОЕ ПИТАНИЕ'
                    },
                    {
                        code: '17.5.3',
                        name: 'ЖЕВАТЕЛЬНАЯ РЕЗИНКА'
                    },
                    {
                        code: '17.5.4',
                        name: 'КОНДИТЕРСКИЕ ИЗДЕЛИЯ (РАЗНОЕ)'
                    },
                    {
                        code: '17.5.5',
                        name: 'ЛЕГКИЕ ЗАКУСКИ (SNACKS)'
                    },
                    {
                        code: '17.5.6',
                        name: 'МОРОЖЕНОЕ'
                    },
                    {
                        code: '17.5.7',
                        name: 'ПРИПРАВЫ И СПЕЦИИ, ВКУСОВЫЕ ДОБАВКИ'
                    },
                    {
                        code: '17.5.8',
                        name: 'ПРОДУКТЫ БЫСТРОЙ ЗАМОРОЗКИ'
                    },
                    {
                        code: '17.5.9',
                        name: 'РАСТИТЕЛЬНОЕ МАСЛО'
                    },
                    {
                        code: '17.5.10',
                        name: 'СОУСЫ, МАЙОНЕЗ'
                    },
                    {
                        code: '17.5.11',
                        name: 'ПРОДУКТЫ ПИТАНИЯ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '18',
        name: 'ПРОХЛАДИТЕЛЬНЫЕ НАПИТКИ, СОКИ',
        children: [
            {
                code: '18.1',
                name: 'ПРОХЛАДИТЕЛЬНЫЕ НАПИТКИ',
                children: [
                    {
                        code: '18.1.1',
                        name: 'ГАЗИРОВАННЫЕ НАПИТКИ'
                    },
                    {
                        code: '18.1.2',
                        name: 'МИНЕРАЛЬНАЯ И ОЧИЩЕННАЯ ПИТЬЕВАЯ ВОДА'
                    },
                    {
                        code: '18.1.3',
                        name: 'ПРОХЛАДИТЕЛЬНЫЕ НАПИТКИ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '18.2',
                name: 'ЭНЕРГЕТИЧЕСКИЕ НАПИТКИ',
                children: [
                    {
                        code: '18.2.1',
                        name: 'ЭНЕРГЕТИЧЕСКИЕ НАПИТКИ'
                    }
                ]
            },
            {
                code: '18.3',
                name: 'СОКИ',
                children: [
                    {
                        code: '18.3.1',
                        name: 'СОКИ'
                    },
                    {
                        code: '18.3.2',
                        name: 'ДЕТСКИЕ СОКИ'
                    },
                    {
                        code: '18.3.3',
                        name: 'СОКИ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        name: 'ПРОИЗВОДСТВЕННОЕ ОБОРУДОВАНИЕ И УСЛУГИ, ТЕХНОЛОГИЧЕСКИЕ МАТЕРИАЛЫ',
        code: '19',
        children: [
            {
                code: '19.1',
                name: 'ОБОРУДОВАНИЕ И ТЕХНОЛОГИЧЕСКИЕ',
                children: [
                    {
                        code: '19.1.1',
                        name: 'БАНКОВСКАЯ ТЕХНИКА'
                    },
                    {
                        code: '19.1.2',
                        name: 'ПРОМЫШЛЕННОЕ, СКЛАДСКОЕ И ТОРГОВОЕ ОБОРУДОВАНИЕ'
                    },
                    {
                        code: '19.1.3',
                        name: 'ПРОМЫШЛЕННОЕ СЫРЬЕ И МАТЕРИАЛЫ'
                    },
                    {
                        code: '19.1.4',
                        name: 'УПАКОВОЧНЫЕ МАТЕРИАЛЫ'
                    },
                    {
                        code: '19.1.5',
                        name: 'ОБОРУДОВАНИЕ И ТЕХНОЛОГИЧЕСКИЕ МАТЕРИАЛЫ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '19.2',
                name: 'ПРОИЗВОДСТВЕННЫЕ УСЛУГИ',
                children: [
                    {
                        code: '19.2.1',
                        name: 'ПРОИЗВОДСТВЕННЫЕ УСЛУГИ'
                    }
                ]
            }
        ]
    },
    {
        code: '20',
        name: 'СМИ',
        children: [
            {
                code: '20.1',
                name: 'СМИ',
                children: [
                    {
                        code: '20.1.1',
                        name: 'СМИ (ИНТЕРНЕТ)'
                    },
                    {
                        code: '20.1.2',
                        name: 'СМИ (ПЕЧАТНЫЕ ИЗДАНИЯ)'
                    },
                    {
                        code: '20.1.3',
                        name: 'СМИ (РАДИО)'
                    },
                    {
                        code: '20.1.4',
                        name: 'СМИ (ТЕЛЕВИДЕНИЕ)'
                    },
                    {
                        code: '20.1.5',
                        name: 'СМИ (РАЗНОЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '21',
        name: 'СОЦИАЛЬНАЯ РЕКЛАМА',
        children: [
            {
                code: '21.1',
                name: 'СОЦИАЛЬНАЯ ПОДДЕРЖКА',
                children: [
                    {
                        code: '21.1.1',
                        name: 'СОЦИАЛЬНОЕ ОБСЛУЖИВАНИЕ НАСЕЛЕНИЯ'
                    },
                    {
                        code: '21.1.2',
                        name: 'ПОМОЩЬ ПРИ СТИХИЙНЫХ БЕДСТВИЯХ, КАТАСТРОФАХ,'
                    },
                    {
                        code: '21.1.3',
                        name: 'ПОМОЩЬ В ПРЕДОТВРАЩЕНИИ НЕСЧАСТНЫХ СЛУЧАЕВ,'
                    },
                    {
                        code: '21.1.4',
                        name: 'ПОДДЕРЖКА ИНВАЛИДОВ'
                    },
                    {
                        code: '21.1.5',
                        name: 'ПОДДЕРЖКА БЛАГОТВОРИТЕЛЬНЫХ ОРГАНИЗАЦИЙ'
                    },
                    {
                        code: '21.1.6',
                        name: 'ВОЛОНТЕРСКАЯ ДЕЯТЕЛЬНОСТЬ'
                    }
                ]
            },
            {
                code: '21.2',
                name: 'ЗДОРОВЬЕ',
                children: [
                    {
                        code: '21.2.1',
                        name: 'ЛЕЧЕНИЕ ЗАБОЛЕВАНИЙ'
                    },
                    {
                        code: '21.2.2',
                        name: 'ПРОФИЛАКТИКА ЗАБОЛЕВАНИЙ'
                    }
                ]
            },
            {
                code: '21.3',
                name: 'ОКРУЖАЮЩАЯ СРЕДА, КУЛЬТУРНЫЕ И',
                children: [
                    {
                        code: '21.3.1',
                        name: 'ЗАЩИТА ЖИВОТНЫХ'
                    },
                    {
                        code: '21.3.2',
                        name: 'ЗАЩИТА ПРИРОДЫ'
                    },
                    {
                        code: '21.3.3',
                        name: 'ЗАЩИТА ОБЪЕКТОВ И ТЕРРИТОРИЙ'
                    }
                ]
            },
            {
                code: '21.4',
                name: 'СОЦИАЛЬНЫЕ ОТНОШЕНИЯ',
                children: [
                    {
                        code: '21.4.1',
                        name: 'ПОВЫШЕНИЕ ПРАВОВОЙ, ФИНАНСОВОЙ ГРАМОТНОСТИ'
                    },
                    {
                        code: '21.4.2',
                        name: 'ПРОФИЛАКТИКА СОЦИАЛЬНО ОПАСНЫХ ФОРМ ПОВЕДЕНИЯ'
                    },
                    {
                        code: '21.4.3',
                        name: 'ПОВЫШЕНИЕ БЕЗОПАСНОСТИ ДОРОЖНОГО ДВИЖЕНИЯ'
                    },
                    {
                        code: '21.4.4',
                        name: 'ПОДДЕРЖКА ОБРАЗОВАНИЯ, КУЛЬТУРЫ И ИСКУССТВА'
                    },
                    {
                        code: '21.4.5',
                        name: 'ПОДДЕРЖКА СПОРТА И ЗДОРОВОГО ОБРАЗА ЖИЗНИ'
                    },
                    {
                        code: '21.4.6',
                        name: 'ПОДДЕРЖКА ПСИХОЛОГИЧЕСКОГО СОСТОЯНИЯ ГРАЖДАН'
                    },
                    {
                        code: '21.4.7',
                        name: 'ФОРМИРОВАНИЕ НЕТЕРПИМОСТИ К НАРУШЕНИЯМ'
                    },
                    {
                        code: '21.4.8',
                        name: 'ЗАЩИТА ТРАДИЦИЙ, КУЛЬТУРЫ, ЯЗЫКОВ НАРОДОВ РФ'
                    },
                    {
                        code: '21.4.9',
                        name: 'ПРОВЕДЕНИЕ ПОИСКОВОЙ РАБОТЫ (НЕИЗВЕСТНЫЕ'
                    },
                    {
                        code: '21.4.10',
                        name: 'СОДЕЙСТВИЕ МОБИЛЬНОСТИ ТРУДОВЫХ РЕСУРСОВ'
                    },
                    {
                        code: '21.4.11',
                        name: 'СОДЕЙСТВИЕ В АДАПТАЦИИ МИГРАНТОВ'
                    },
                    {
                        code: '21.4.12',
                        name: 'ГРАЖДАНСКОЕ УЧАСТИЕ В ВЫБОРАХ И РЕФЕРЕНДУМАХ'
                    },
                    {
                        code: '21.4.13',
                        name: 'ПОМОЩЬ БЕЖЕНЦАМ И ПЕРЕСЕЛЕНЦАМ'
                    }
                ]
            }
        ]
    },
    {
        code: '22',
        name: 'СРЕДСТВА И ПРЕДМЕТЫ ГИГИЕНЫ',
        children: [
            {
                code: '22.1',
                name: 'БРИТВЕННЫЕ СИСТЕМЫ',
                children: [
                    {
                        code: '22.1.1',
                        name: 'БРИТВЕННЫЕ СИСТЕМЫ'
                    }
                ]
            },
            {
                code: '22.2',
                name: 'СРЕДСТВА И ПРЕДМЕТЫ ГИГИЕНЫ',
                children: [
                    {
                        code: '22.2.1',
                        name: 'ГИГИЕНИЧЕСКИЕ ПРОКЛАДКИ, ТАМПОНЫ'
                    },
                    {
                        code: '22.2.2',
                        name: 'СРЕДСТВА ГИГИЕНЫ ДЛЯ ЖЕНЩИН'
                    },
                    {
                        code: '22.2.3',
                        name: 'ПОДГУЗНИКИ'
                    },
                    {
                        code: '22.2.4',
                        name: 'СРЕДСТВА ГИГИЕНЫ ДЛЯ ДЕТЕЙ'
                    },
                    {
                        code: '22.2.5',
                        name: 'СРЕДСТВА И ПРЕДМЕТЫ ГИГИЕНЫ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '22.3',
                name: 'СРЕДСТВА И ПРЕДМЕТЫ ГИГИЕНЫ РТА',
                children: [
                    {
                        code: '22.3.1',
                        name: 'ЗУБНАЯ ПАСТА'
                    },
                    {
                        code: '22.3.2',
                        name: 'ЗУБНЫЕ ЩЕТКИ'
                    },
                    {
                        code: '22.3.3',
                        name: 'СРЕДСТВА ДЛЯ ГИГИЕНЫ РТА'
                    },
                    {
                        code: '22.3.4',
                        name: 'СРЕДСТВА ГИГИЕНЫ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '23',
        name: 'СРЕДСТВА СВЯЗИ, ОБОРУДОВАНИЕ ДЛЯ СВЯЗИ',
        children: [
            {
                code: '23.1',
                name: 'МОБИЛЬНЫЕ УСТРОЙСТВА СВЯЗИ',
                children: [
                    {
                        code: '23.1.1',
                        name: 'СОТОВЫЕ ТЕЛЕФОНЫ'
                    },
                    {
                        code: '23.1.2',
                        name: 'МОБИЛЬНЫЕ УСТРОЙСТВА СВЯЗИ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '23.2',
                name: 'ОБОРУДОВАНИЕ ДЛЯ СВЯЗИ',
                children: [
                    {
                        code: '23.2.1',
                        name: 'ОБОРУДОВАНИЕ ДЛЯ СВЯЗИ'
                    }
                ]
            }
        ]
    },
    {
        code: '24',
        name: 'СТРОИТЕЛЬНЫЕ ТОВАРЫ И УСЛУГИ',
        children: [
            {
                code: '24.1',
                name: 'СТРОЙМАТЕРИАЛЫ И ОБОРУДОВАНИЕ',
                children: [
                    {
                        code: '24.1.1',
                        name: 'ОКНА И РАМЫ'
                    },
                    {
                        code: '24.1.2',
                        name: 'ОТДЕЛОЧНЫЕ МАТЕРИАЛЫ'
                    },
                    {
                        code: '24.1.3',
                        name: 'ОТОПИТЕЛЬНОЕ ОБОРУДОВАНИЕ'
                    },
                    {
                        code: '24.1.4',
                        name: 'САНТЕХНИКА'
                    },
                    {
                        code: '24.1.5',
                        name: 'САНТЕХНИЧЕСКОЕ ОБОРУДОВАНИЕ'
                    },
                    {
                        code: '24.1.6',
                        name: 'СТРОИТЕЛЬНЫЕ ИНСТРУМЕНТЫ И ОБОРУДОВАНИЕ'
                    },
                    {
                        code: '24.1.7',
                        name: 'СТРОИТЕЛЬНЫЕ КОНСТРУКЦИИ'
                    },
                    {
                        code: '24.1.8',
                        name: 'СТРОИТЕЛЬНЫЕ МАТЕРИАЛЫ'
                    },
                    {
                        code: '24.1.9',
                        name: 'ЭЛЕКТРООБОРУДОВАНИЕ'
                    },
                    {
                        code: '24.1.10',
                        name: 'СТРОЙМАТЕРИАЛЫ И ОБОРУДОВАНИЕ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '24.2',
                name: 'СТРОИТЕЛЬСТВО И РЕМОНТ',
                children: [
                    {
                        code: '24.2.1',
                        name: 'СТРОИТЕЛЬСТВО И РЕМОНТ'
                    }
                ]
            }
        ]
    },
    {
        code: '25',
        name: 'ТЕЛЕКОМ',
        children: [
            {
                code: '25.1',
                name: 'УСЛУГИ СВЯЗИ',
                children: [
                    {
                        code: '25.1.1',
                        name: 'УСЛУГИ СОТОВОЙ СВЯЗИ'
                    },
                    {
                        code: '25.1.2',
                        name: 'ИНТЕРНЕТ-ПРОВАЙДЕР'
                    },
                    {
                        code: '25.1.3',
                        name: 'КАРТЫ ДЛЯ ОПЛАТЫ УСЛУГ СВЯЗИ'
                    },
                    {
                        code: '25.1.4',
                        name: 'КОМПЬЮТЕРНЫЕ СЕТИ'
                    },
                    {
                        code: '25.1.5',
                        name: 'УСЛУГИ СВЯЗИ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '25.2',
                name: 'ТЕЛЕКОММУНИКАЦИОННОЕ',
                children: [
                    {
                        code: '25.2.1',
                        name: 'ТЕЛЕКОММУНИКАЦИОННОЕ ОБОРУДОВАНИЕ'
                    }
                ]
            }
        ]
    },
    {
        code: '26',
        name: 'ТОВАРЫ ДЛЯ ДЕТЕЙ',
        children: [
            {
                code: '26.1',
                name: 'ДЕТСКИЕ КОЛЯСКИ',
                children: [
                    {
                        code: '26.1.1',
                        name: 'ДЕТСКИЕ КОЛЯСКИ'
                    }
                ]
            },
            {
                code: '26.2',
                name: 'ИГРУШКИ И ИГРЫ',
                children: [
                    {
                        code: '26.2.1',
                        name: 'ИГРУШКИ'
                    },
                    {
                        code: '26.2.2',
                        name: 'ИГРЫ'
                    }
                ]
            },
            {
                code: '26.3',
                name: 'СРЕДСТВА ДЕТСКОЙ ГИГИЕНЫ',
                children: [
                    {
                        code: '26.3.1',
                        name: 'СРЕДСТВА ДЕТСКОЙ ГИГИЕНЫ'
                    }
                ]
            },
            {
                code: '26.4',
                name: 'ТОВАРЫ ДЛЯ ДЕТЕЙ (ПРОЧЕЕ)',
                children: [
                    {
                        code: '26.4.1',
                        name: 'ДЕТСКИЕ АВТОКРЕСЛА'
                    },
                    {
                        code: '26.4.2',
                        name: 'ПОСТЕЛЬНЫЕ ПРИНАДЛЕЖНОСТИ ДЛЯ ДЕТЕЙ'
                    },
                    {
                        code: '26.4.3',
                        name: 'ПРИНАДЛЕЖНОСТИ ДЛЯ КОРМЛЕНИЯ ДЕТЕЙ'
                    },
                    {
                        code: '26.4.4',
                        name: 'ПРИНАДЛЕЖНОСТИ ПО УХОДУ ЗА ДЕТЬМИ'
                    },
                    {
                        code: '26.4.5',
                        name: 'ТОВАРЫ ДЛЯ ДЕТЕЙ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '27',
        name: 'ТОВАРЫ ДЛЯ ЖИВОТНЫХ',
        children: [
            {
                code: '27.1',
                name: 'КОРМ ДЛЯ ЖИВОТНЫХ',
                children: [
                    {
                        code: '27.1.1',
                        name: 'КОРМ ДЛЯ ДОМАШНИХ ЖИВОТНЫХ'
                    },
                    {
                        code: '27.1.2',
                        name: 'ПРОДАЖА: КОРМА ДЛЯ СЕЛЬСКОГО ХОЗЯЙСТВА'
                    }
                ]
            },
            {
                code: '27.2',
                name: 'ТОВАРЫ ДЛЯ ЖИВОТНЫХ (ПРОЧЕЕ)',
                children: [
                    {
                        code: '27.2.1',
                        name: 'ТОВАРЫ ДЛЯ ЖИВОТНЫХ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '28',
        name: 'ТОРГОВЫЕ ОРГАНИЗАЦИИ',
        children: [
            {
                code: '28.1',
                name: 'ТОРГОВЫЕ ОРГАНИЗАЦИИ',
                children: [
                    {
                        code: '28.1.1',
                        name: 'АПТЕКИ И ОПТИКИ'
                    },
                    {
                        code: '28.1.2',
                        name: 'МАГАЗИНЫ АВТО- МОТОТЕХНИКИ, ЗАПЧАСТЕЙ И'
                    },
                    {
                        code: '28.1.3',
                        name: 'МАГАЗИНЫ БЫТОВОЙ ТЕХНИКИ И ЭЛЕКТРОНИКИ'
                    },
                    {
                        code: '28.1.4',
                        name: 'МАГАЗИНЫ МЕБЕЛИ И ТОВАРОВ ДЛЯ ДОМА'
                    },
                    {
                        code: '28.1.5',
                        name: 'МАГАЗИНЫ МЕХОВ И КОЖАНОЙ ОДЕЖДЫ'
                    },
                    {
                        code: '28.1.6',
                        name: 'МАГАЗИНЫ ОДЕЖДЫ И ОБУВИ'
                    },
                    {
                        code: '28.1.7',
                        name: 'МАГАЗИНЫ ПО ПРОДАЖЕ ПАРФЮМЕРИИ И КОСМЕТИКИ'
                    },
                    {
                        code: '28.1.8',
                        name: 'МАГАЗИНЫ ПРОДУКТОВЫЕ'
                    },
                    {
                        code: '28.1.9',
                        name: 'МАГАЗИНЫ СПОРТИВНЫХ ТОВАРОВ'
                    },
                    {
                        code: '28.1.10',
                        name: 'МАГАЗИНЫ ТОВАРОВ ДЛЯ СТРОИТЕЛЬСТВА И РЕМОНТА'
                    },
                    {
                        code: '28.1.11',
                        name: 'МАГАЗИНЫ ЮВЕЛИРНЫХ ИЗДЕЛИЙ'
                    },
                    {
                        code: '28.1.12',
                        name: 'САЛОНЫ СОТОВОЙ СВЯЗИ'
                    },
                    {
                        code: '28.1.13',
                        name: 'ТОРГОВЫЕ ЦЕНТРЫ И ТОРГОВЫЕ ДОМА'
                    },
                    {
                        code: '28.1.14',
                        name: 'ЯРМАРКИ, ВЫСТАВКА-ПРОДАЖА'
                    },
                    {
                        code: '28.1.15',
                        name: 'ТОРГОВЫЕ ОРГАНИЗАЦИИ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '29',
        name: 'ФИНАНСОВЫЕ И СТРАХОВЫЕ УСЛУГИ',
        children: [
            {
                code: '29.1',
                name: 'СТРАХОВЫЕ УСЛУГИ',
                children: [
                    {
                        code: '29.1.1',
                        name: 'АВТОСТРАХОВАНИЕ'
                    },
                    {
                        code: '29.1.2',
                        name: 'СТРАХОВЫЕ УСЛУГИ ДЛЯ ФИЗИЧЕСКИХ ЛИЦ'
                    },
                    {
                        code: '29.1.3',
                        name: 'СТРАХОВЫЕ УСЛУГИ ДЛЯ ЮРИДИЧЕСКИХ ЛИЦ'
                    },
                    {
                        code: '29.1.4',
                        name: 'СТРАХОВЫЕ УСЛУГИ (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '29.2',
                name: 'ФИНАНСОВЫЕ УСЛУГИ',
                children: [
                    {
                        code: '29.2.1',
                        name: 'БАНКОВСКИЕ ВКЛАДЫ'
                    },
                    {
                        code: '29.2.2',
                        name: 'КРЕДИТОВАНИЕ ФИЗИЧЕСКИХ ЛИЦ'
                    },
                    {
                        code: '29.2.3',
                        name: 'КРЕДИТОВАНИЕ ЮРИДИЧЕСКИХ ЛИЦ'
                    },
                    {
                        code: '29.2.4',
                        name: 'ОПЕРАЦИИ С ЦЕННЫМИ БУМАГАМИ'
                    },
                    {
                        code: '29.2.5',
                        name: 'ПАЕВЫЕ ИНВЕСТИЦИОННЫЕ ФОНДЫ'
                    },
                    {
                        code: '29.2.6',
                        name: 'ПЛАТЕЖНЫЕ СИСТЕМЫ, ПЛАСТИКОВЫЕ КАРТЫ'
                    },
                    {
                        code: '29.2.7',
                        name: 'УСЛУГИ БАНКОВ (ПРОЧЕЕ)'
                    },
                    {
                        code: '29.2.8',
                        name: 'УСЛУГИ ПЕНСИОННЫХ ФОНДОВ'
                    },
                    {
                        code: '29.2.9',
                        name: 'ФИНАНСОВЫЕ УСЛУГИ (ПРОЧЕЕ)'
                    }
                ]
            }
        ]
    },
    {
        code: '30',
        name: 'ПРОЧИЕ ТОВАРЫ И УСЛУГИ',
        children: [
            {
                code: '30.1',
                name: 'АУДИО-, ВИДЕОПРОДУКЦИЯ, ИГРЫ',
                children: [
                    {
                        code: '30.1.1',
                        name: 'АУДИО-, ВИДЕОПРОДУКЦИЯ, ИГРЫ'
                    },
                    {
                        code: '30.1.2',
                        name: 'ЭЛЕКТРОННЫЕ ВЕРСИИ ПЕЧАТНЫХ ИЗДАНИЙ'
                    },
                    {
                        code: '30.1.3',
                        name: 'ЭЛЕКТРОННЫЕ ИЗДАНИЯ'
                    }
                ]
            },
            {
                code: '30.2',
                name: 'БЫТОВОЙ СЕРВИС',
                children: [
                    {
                        code: '30.2.1',
                        name: 'ПРОКАТ'
                    },
                    {
                        code: '30.2.2',
                        name: 'ПОШИВ ОДЕЖДЫ И ОБУВИ'
                    },
                    {
                        code: '30.2.3',
                        name: 'БЫТОВОЙ РЕМОНТ'
                    },
                    {
                        code: '30.2.4',
                        name: 'УСЛУГИ ХИМЧИСТОК  И ПРАЧЕЧНЫХ'
                    },
                    {
                        code: '30.2.5',
                        name: 'УСЛУГИ ФОТО, КИНО, ВИДЕО, АУДИО'
                    },
                    {
                        code: '30.2.6',
                        name: 'УСЛУГИ ПАРИКМАХЕРСКИХ И КОСМЕТИЧ. САЛОНОВ'
                    },
                    {
                        code: '30.2.7',
                        name: 'ДОСТАВКА, КУРЬЕРЫ,ЭКСПЕДИТОРЫ'
                    },
                    {
                        code: '30.2.8',
                        name: 'УСЛУГИ ИНФОРМАЦИОННЫЕ'
                    },
                    {
                        code: '30.2.9',
                        name: 'УСЛУГИ ПО УБОРКЕ ОФИСОВ И КВАРТИР'
                    },
                    {
                        code: '30.2.10',
                        name: 'УСЛУГИ ЖИЛИЩНО-КОММУНАЛЬНЫЕ'
                    },
                    {
                        code: '30.2.11',
                        name: 'УСЛУГИ БЫТОВЫЕ И СЕРВИС (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '30.3',
                name: 'ГАЛАНТЕРЕЯ И АКСЕССУАРЫ',
                children: [
                    {
                        code: '30.3.1',
                        name: 'ЗАЖИГАЛКИ, КУРИТЕЛЬНЫЕ ПРИНАДЛЕЖНОСТИ'
                    },
                    {
                        code: '30.3.2',
                        name: 'ТЕКСТИЛЬНАЯ ГАЛАНТЕРЕЯ'
                    },
                    {
                        code: '30.3.3',
                        name: 'СУМКИ'
                    },
                    {
                        code: '30.3.4',
                        name: 'ГАЛАНТЕРЕЯ И АКСЕССУАРЫ (ПРОЧЕЕ)'
                    },
                    {
                        code: '30.3.5',
                        name: 'МУЗЫКАЛЬНЫЕ ИНСТРУМЕНТЫ'
                    }
                ]
            },
            {
                code: '30.4',
                name: 'КАНЦТОВАРЫ, КНИГИ, ПОЛИГРАФИЯ',
                children: [
                    {
                        code: '30.4.1',
                        name: 'КАНЦТОВАРЫ'
                    },
                    {
                        code: '30.4.2',
                        name: 'КНИГИ И ДРУГАЯ ПОЛИГРАФИЯ'
                    }
                ]
            },
            {
                code: '30.5',
                name: 'ОБРАЗОВАНИЕ И ТРУДОУСТРОЙСТВО',
                children: [
                    {
                        code: '30.5.1',
                        name: 'ОБРАЗОВАТЕЛЬНЫЕ УСЛУГИ'
                    },
                    {
                        code: '30.5.2',
                        name: 'УСЛУГИ ПО ТРУДОУСТРОЙСТВУ'
                    }
                ]
            },
            {
                code: '30.6',
                name: 'ОРУЖИЕ, СРЕДСТВА ЗАЩИТЫ И',
                children: [
                    {
                        code: '30.6.1',
                        name: 'ОРУЖИЕ И СРЕДСТВА ЗАЩИТЫ'
                    },
                    {
                        code: '30.6.2',
                        name: 'ТЕХНИЧЕСКИЕ СРЕДСТВА БЕЗОПАСНОСТИ'
                    },
                    {
                        code: '30.6.3',
                        name: 'УСЛУГИ ПО ОХРАНЕ И БЕЗОПАСНОСТИ'
                    }
                ]
            },
            {
                code: '30.7',
                name: 'ОХОТНИЧЬИ И РЫБОЛОВНЫЕ ТОВАРЫ',
                children: [
                    {
                        code: '30.7.1',
                        name: 'ОХОТНИЧЬИ И РЫБОЛОВНЫЕ ТОВАРЫ'
                    }
                ]
            },
            {
                code: '30.8',
                name: 'ТОВАРЫ ДЛЯ САДА И ОГОРОДА',
                children: [
                    {
                        code: '30.8.1',
                        name: 'РАСТЕНИЯ, РАССАДА, СЕМЕНА'
                    },
                    {
                        code: '30.8.2',
                        name: 'САДОВАЯ ТЕХНИКА'
                    },
                    {
                        code: '30.8.3',
                        name: 'АГРОХИМИЯ, ПОЧВОГРУНТЫ, УДОБРЕНИЯ'
                    },
                    {
                        code: '30.8.4',
                        name: 'ТОВАРЫ ДЛЯ САДА И ОГОРОДА (ПРОЧЕЕ)'
                    }
                ]
            },
            {
                code: '30.9',
                name: 'ТРАНСПОРТНЫЕ УСЛУГИ',
                children: [
                    {
                        code: '30.9.1',
                        name: 'ТРАНСПОРТНЫЕ УСЛУГИ'
                    }
                ]
            },
            {
                code: '30.10',
                name: 'УСЛУГИ В ОБЛАСТИ РЕКЛАМЫ И',
                children: [
                    {
                        code: '30.10.1',
                        name: 'РАЗМЕЩЕНИЕ РЕКЛАМЫ'
                    },
                    {
                        code: '30.10.2',
                        name: 'ИЗГОТОВЛЕНИЕ РЕКЛАМЫ'
                    },
                    {
                        code: '30.10.3',
                        name: 'УСЛУГИ В ОБЛ. РЕКЛАМЫ И МАРКЕТИНГА (ПРОЧЕЕ) (B2B)'
                    }
                ]
            },
            {
                code: '30.11',
                name: 'УСЛУГИ В ОБЛАСТИ ФИЗКУЛЬТУРЫ И',
                children: [
                    {
                        code: '30.11.1',
                        name: 'УСЛУГИ В ОБЛАСТИ ФИЗКУЛЬТУРЫ И СПОРТА'
                    },
                    {
                        code: '30.11.2',
                        name: 'СПОРТИВНЫЙ ИНВЕНТАРЬ'
                    }
                ]
            },
            {
                code: '30.12',
                name: 'ЦВЕТЫ И ПРОЧИЕ РАСТЕНИЯ',
                children: [
                    {
                        code: '30.12.1',
                        name: 'ЦВЕТЫ И ПРОЧИЕ РАСТЕНИЯ'
                    }
                ]
            },
            {
                code: '30.13',
                name: 'ЮВЕЛИРНЫЕ ИЗДЕЛИЯ И ЧАСЫ',
                children: [
                    {
                        code: '30.13.1',
                        name: 'ЧАСЫ'
                    },
                    {
                        code: '30.13.2',
                        name: 'ЮВЕЛИРНЫЕ ИЗДЕЛИЯ'
                    }
                ]
            },
            {
                code: '30.14',
                name: 'ЮРИДИЧЕСКИЕ, АУДИТОРСКИЕ И',
                children: [
                    {
                        code: '30.14.1',
                        name: 'ЮРИДИЧЕСКИЕ, АУДИТОРСКИЕ И КОНСАЛТИНГОВЫЕ УСЛУГИ'
                    }
                ]
            },
            {
                code: '30.15',
                name: 'ПРОЧИЕ ТОВАРЫ И УСЛУГИ',
                children: [
                    {
                        code: '30.15.1',
                        name: 'ПРОЧИЕ ТОВАРЫ И УСЛУГИ'
                    }
                ]
            }
        ]
    }
]
